var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.057373H44.6432V43.0574H0V0.057373Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2798 21.7791L42.4344 7.75132C44.1117 6.08866 44.1117 3.39232 42.4344 1.72966C40.7522 0.0670011 38.0364 0.0670011 36.3591 1.72966L22.2046 15.7574L8.05 1.72966C6.37271 0.0670011 3.65199 0.0670011 1.96983 1.72966C0.292543 3.39232 0.292543 6.08866 1.96983 7.75132L16.1244 21.7791L1.9357 35.8361C0.258412 37.4988 0.258412 40.1951 1.9357 41.8578C2.77434 42.6867 3.87628 43.106 4.97335 43.106C6.07529 43.106 7.17235 42.6867 8.01587 41.8578L22.1997 27.8008L36.3542 41.8237C37.1929 42.6526 38.2948 43.0719 39.3919 43.0719C40.4889 43.0719 41.5909 42.6526 42.4295 41.8237C44.1068 40.161 44.1068 37.4647 42.4295 35.802L28.2798 21.7791Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bc1fc42f14d9304c6132bab1585f6fd9.svg";
export { ForwardRef as ReactComponent };